export const LISTING_ITEM_FLAW_ROWS = [
  ['scratches', 'stains', 'cracks', 'repairs'],
  ['missing_parts', 'discoloration', 'other'],
];

export const LISTING_ITEM_FLAW_LABELS = {
  scratches: 'scratches',
  stains: 'stains',
  cracks: 'cracks',
  repairs: 'repairs',
  missing_parts: 'missing parts',
  discoloration: 'discoloration',
  other: 'other',
};

export function formatListingItemFlawLabel(key) {
  return LISTING_ITEM_FLAW_LABELS[key] || String(key).replace(/_/g, ' ');
}

export function normalizeListingItemFlaws(value) {
  if (!Array.isArray(value)) {
    return [];
  }
  return value.filter((key) => LISTING_ITEM_FLAW_LABELS[key]);
}
